import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Player.css";
import PropTypes from "prop-types";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import RepeatIcon from "@material-ui/icons/Repeat";
import RepeatOneIcon from "@material-ui/icons/RepeatOne";
import PauseIcon from "@material-ui/icons/Pause";
import IconButton from "@material-ui/core/IconButton";
import {
  playAudio,
  pauseAudio,
  clearAudio,
  setAudioProgress,
  setAudioBuffer,
  endAudio, 
  setPopoutFor, 
} from "redux/actions/PlayerActions";
import PlayerProgress from "./PlayerProgress/PlayerProgress";
import PlayerVolume from "./PlayerVolume/PlayerVolume";
import { loopPlay, unloopPlay } from "redux/actions/PlayerActions";
import { audioError } from "../../redux/actions/PlayerActions";
import Badge from "@material-ui/core/Badge";
import DownloadLink from "./../../util/downloader/DownloadLink";
import { PlayableTypes } from "./PlayerRef/PlayerRef";
import PlayerPlaylist from "./PlayerPlaylist";
import { playPlaylistTrack, abuseMsgClose } from './../../redux/actions/PlayerActions';
import { Snackbar, CircularProgress, } from "@material-ui/core";
import { Link } from "react-router-dom";
import Confirm from "../../util/Confirm";
import { activityLimitActions } from "../../util/UserActivityLimit";
import clsx from "clsx";

class MetadataPopupPlayer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const {
      player: { audioPlayer, playProgress, isBufferCompleted },
      handleSetAudioBuffer,
      handleEndAudio,
      handleAudioError,
      handleSetAudioProgress,
    } = this.props;

    audioPlayer.onerror = () => {
      switch (audioPlayer.error.code) {
        case audioPlayer.error.MEDIA_ERR_ABORTED:
          handleAudioError("You have aborted the audio playback.");
          break;
        case audioPlayer.error.MEDIA_ERR_NETWORK:
          handleAudioError(
            "A network error caused the audio download to fail."
          );
          handleEndAudio({withError: true, errorMessage: "A network error caused the audio download to fail."});
          break;
        case audioPlayer.error.MEDIA_ERR_DECODE:
          handleAudioError(
            "The audio playback was aborted due to a corruption or the audio used features your browser did not support."
          );
          handleEndAudio({withError: true, errorMessage: "The audio playback was aborted due to a corruption or the audio used features your browser did not support."});
          break;
        case audioPlayer.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
          handleAudioError(
            "The audio has not loaded due to server or network failure."
          );
          handleEndAudio({withError: true, errorMessage: "The audio has not loaded due to server or network failure."});
          break;
        default:
          handleAudioError("Unknown error.");
          handleEndAudio({withError: true, errorMessage: "Unknown error."});
          break;
      }
    };

    audioPlayer.onprogress = () => {
      if (audioPlayer && audioPlayer.buffered.length > 0) {
        const bufferEnd = audioPlayer.buffered.end(
          audioPlayer.buffered.length - 1
        );
        var bufferProgress = Math.trunc(
          (bufferEnd * 100) / audioPlayer.duration
        );
        handleSetAudioBuffer({
          bufferTime: bufferEnd,
          bufferProgress: bufferProgress,
          playDuration: audioPlayer.duration,
        });
      }
    };

    audioPlayer.onended = () => {
      if (audioPlayer) {
        handleEndAudio();
      }
    };

    audioPlayer.ontimeupdate = () => {
      if (audioPlayer && audioPlayer.currentTime) {
        var playProgressCalc = Math.trunc(
          (audioPlayer.currentTime * 100) / audioPlayer.duration
        );
        if (playProgress !== playProgressCalc) {
          if (!isBufferCompleted) {
            const bufferEnd = audioPlayer.buffered.end(
              audioPlayer.buffered.length - 1
            );
            var bufferProgress = Math.trunc(
              (bufferEnd * 100) / audioPlayer.duration
            );
            handleSetAudioProgress({
              playTime: audioPlayer.currentTime,
              playProgress: playProgressCalc,
              bufferTime: bufferEnd,
              bufferProgress: bufferProgress,
              playDuration: audioPlayer.duration,
            });
          } else {
            handleSetAudioProgress({
              playTime: audioPlayer.currentTime,
              playProgress: playProgressCalc,
              playDuration: audioPlayer.duration,
            });
          }
        }
      }
    };
  }

  handleCloseAbuseMsg = (abuseFlag) => {
    this.props.handleCloseAbuseMsg(); 
    activityLimitActions(abuseFlag);
  }

  showMessage = (msg) => {
    this.setState({ message: msg });
  };

  trackId = null;

  render() {
    const {
      item, 
      classes,
      player: {
        tracksLoading,
        isAssetLoading,
        // track,
        isLoop,
        isPlaying,
        isAudioError,
        errorMessage,
        audioPlayer,
        playableType,
        snackbar: { snackbarMessage }
      },
      handleLoopPlay,
      handleUnloopPlay,
      handlePlayAudio,
      handlePauseAudio,
      setPopoutFor, 
      popoutFor,
      plId
    } = this.props;
    let track = item;
    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <div className={classes.playerContainer}>
              <div className={classes.PlayerControls}>
                <IconButton
                  aria-label={t("player.playButton")}
                  title={t("player.playButton")}
                  className={classes.tablePlayNow}
                  onClick={() => {
                    handlePlayAudio({
                      item,
                      playableType:PlayableTypes.track,
                      showMessage: this.showMessage,
                      plId
                    })
                    if(popoutFor){
                      setPopoutFor(popoutFor);
                    }
                  }}
                >
                  <PlayArrowIcon />
                </IconButton>
              </div>
              <div className={classes.trackName}>


                <div
                  aria-label={t("player.playProgress")}    
                  className={clsx(classes.PlayerProgress, "popupPlayerProgress")}
                  title={t("player.playProgress")}
                >
                  <PlayerProgress
                    item={item}
                    locate={(time) => {
                      if (
                        !audioPlayer.paused &&
                        audioPlayer.buffered.length > 0
                      ) {
                        audioPlayer.currentTime = time;
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

MetadataPopupPlayer.propTypes = {
  player: PropTypes.object.isRequired,
  handlePlayAudio: PropTypes.func.isRequired,
  handlePauseAudio: PropTypes.func.isRequired,
  handleClearAudio: PropTypes.func.isRequired,
  handleSetAudioProgress: PropTypes.func.isRequired,
  handleSetAudioBuffer: PropTypes.func.isRequired,
  handleLoopPlay: PropTypes.func.isRequired,
  handleUnloopPlay: PropTypes.func.isRequired,
  handleEndAudio: PropTypes.func.isRequired,
  handleAudioError: PropTypes.func.isRequired,
  handleCloseAbuseMsg: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    handlePlayAudio: (payload) => dispatch(playAudio(payload)),
    handlePauseAudio: () => dispatch(pauseAudio()),
    handleClearAudio: () => dispatch(clearAudio()),
    handleSetAudioProgress: (payload) => dispatch(setAudioProgress(payload)),
    handleSetAudioBuffer: (payload) => dispatch(setAudioBuffer(payload)),
    handleLoopPlay: () => dispatch(loopPlay()),
    handleUnloopPlay: () => dispatch(unloopPlay()),
    handleEndAudio: (payload) => dispatch(endAudio(payload)),
    handleAudioError: (payload) => dispatch(audioError(payload)),
    handleCloseAbuseMsg: (payload) => dispatch(abuseMsgClose(payload)),
    handlePlayPlaylistTrack: (payload) => dispatch(playPlaylistTrack(payload)), 
    setPopoutFor: (payload) => dispatch(setPopoutFor(payload))
  };
};

const mapStateToProps = (state) => ({
  player: state.player,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MetadataPopupPlayer));
